import "./style.css"

export default function HeartRateAnimation() {
    return (
        <div className="container">
            <svg viewBox="0 0 300 120" className="svg" fill="none" xmlns="http://www.w3.org/2000/svg">
                <polyline
                    points="0,60 10,60 15,50 20,70 25,55 30,65 35,60 50,60 55,45 60,75 65,55 70,65 75,60 90,60 100,60 110,60 120,50 125,70 130,55 135,65 140,60 155,60 160,45 165,75 170,55 175,65 180,60 195,60 200,60 210,60 220,50 225,70 230,55 235,65 240,60 255,60 260,45 265,75 270,55 275,65 280,60 290,60 300,60"
                    stroke="#508fe7"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="polyline"
                />

                {/* Pulsing dots at key points */}
                <circle cx="20" cy="70" r="3" fill="#508fe7" className={"dot"} />
                <circle cx="60" cy="75" r="3" fill="#508fe7" className={"dot"} style={{ animationDelay: "0.2s" }} />
                <circle cx="125" cy="70" r="3" fill="#508fe7" className={"dot"} style={{ animationDelay: "0.4s" }} />
                <circle cx="165" cy="75" r="3" fill="#508fe7" className={"dot"} style={{ animationDelay: "0.6s" }} />
                <circle cx="225" cy="70" r="3" fill="#508fe7" className={"dot"} style={{ animationDelay: "0.8s" }} />
                <circle cx="265" cy="75" r="3" fill="#508fe7" className={"dot"} style={{ animationDelay: "1s" }} />
            </svg>
        </div>
    )
}
